import { Component, inject } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-delete-story-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
  ],
  templateUrl: './delete-story-dialog.html',
  styleUrl: './delete-story-dialog.scss',
})
export class DeleteStoryDialog {
  private readonly dialogRef = inject(MatDialogRef<DeleteStoryDialog>);

  public onUserClick(deleteStory: boolean): void {
    this.dialogRef.close(deleteStory);
  }
}
